<template>
  <div class="faq my-5 dark-color">
    <b-container fluid>
      <b-row class="d-flex align-items-center p-5">
        <b-col cols="12" lg="4" class="text-right-lg text-white">
          <div class="py-3">
            <h2 class="display-4 upper bold">questions<br>
            <span class="text-blue">fréquentes</span></h2>
          </div>
        </b-col>

        <b-col class="px-5">
          <div role="tablist">
            <div class="w-100 mb-5 hr-theme-slash">
              <div class="hr-line"></div>
              <div class="hr-icon"><font-awesome-icon icon="question-circle" size="3x"/></div>
              <div class="hr-line"></div>
            </div>

            <b-card v-for="(faq, index) in faqs" v-bind:key="faq.icon" no-body class="">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button 
                  block 
                  href="#" 
                  v-b-toggle="'accordion-' + (index + 1)" 
                  class="dark-color"
                >
                  <div class="d-flex align-items-center">
                    <div class="d-inline mr-3"><font-awesome-icon class="" :icon="faq.icon" size="2x" /></div>
                    <div class="d-inline text-left"><b>{{ faq.question }}</b></div>
                  </div>         
                </b-button>
              </b-card-header>

              <b-collapse :id="'accordion-' + (index + 1)" accordion="faq-accordion" role="tabpanel">
                <b-card-body class="">
                  <b-card-text class="px-3 mb-3">
                    <p v-for="(p, index) in faq.answer" v-bind:key="faq.icon + '-' + index" class="text-white">{{ p }}</p>
                    <router-link class="text-blue" :to="faq.button.link">{{ faq.button.text }}</router-link>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </b-container>    
  </div>
</template>

<script>
export default {
  name: 'FAQ',
  components: {},
  data() {
    return {
      faqs: [
        {
          icon: 'archive',
          question: 'Pourquoi numériser les documents ?',
          answer: [
            `Les entreprises qui choisissent de numériser leurs documents le font, premièrement, parce 
            que le papier coûte cher, qu'il soit question d'imprimer ou d'archiver.`,
            `La gestion de documents papier implique une concentration des ressources de l'entreprise 
            autour de tâches sans valeur ajoutée telles que la recherche et le classement de documents.`,
            `Elle requiert de l'équipement d'impression ainsi que l'entretien régulier de celui-ci. Elle 
            nécessite aussi l'achat de matériel servant à l'entreposage ou à l'archivage de documents 
            ainsi que l'utilisation d'un espace considérable, souvent équivalent à un poste de travail ou plus.`
          ],
          button: {
            text: `(consultez notre blog pour en apprendre davantage)`,
            link: { name: `blog` }
          }
        },
        {
          icon: 'laptop',
          question: 'Que signifie "Gestion électronique des documents, ou GED ?',
          answer: [
            `Aussi connue sous le nom de Gestion de Contenu d'Entreprise ou de Gestion Verte des Documents, 
            la Gestion Électronique de Documents désigne une méthode d'organisation efficace des documents 
            d'une organisation rendue possible grâce à l'emploi d'outils technologiques divers.`,
            `L'objectif visé est l'accessibilité sécuritaire et immédiate des documents critiques d'une 
            organisation ainsi que la mise en valeur des données dont ils sont porteurs.`,
            `Objectivement, la seule valeur d'un document est celle de l'information qu'il véhicule. 
            Cette valeur ne peut être extraite que dans la mesure où cette information est facilement et 
            rapidement accessible aux personnes qui en ont besoin.`
          ],
          button: {
            text: `(consultez notre blog pour en apprendre davantage)`,
            link: { name: `blog` }
          }
        },
        {
          icon: 'chart-line',
          question: `Qu'est-ce qu'une tâche sans valeur ajoutée ?`,
          answer: [
            `Une tâche sans valeur ajoutée est une tâche répétitive et prévisible qui ne requiert pas de 
            connaissances particulières, d'expérience ou d'exercice de jugement pour être effectuée.`,
            `Ces tâches peuvent généralement être accomplies beaucoup plus rapidement, beaucoup plus 
            précisément et avec plus de constance par un ordinateur équipé des logiciels appropriés.`,
            `Une entreprise optant pour la mise-en-place de telles ressources permet à son personnel de 
            se concentrer sur les tâches que seul l'être humain est en mesure de réaliser et augmente ainsi 
            sa rentabilité.`
          ],
          button: {
            text: `(consultez notre blog pour en apprendre davantage)`,
            link: { name: `blog` }
          }
        },
        {
          icon: 'shield-alt',
          question: `En quoi la GED peut-elle contribuer à renforcer la sécurité des données de mon organisation ?`,
          answer: [
            `La gestion de documents papier expose une organisation à plusieurs risques. D'une part parce que les 
            documents papier peuvent être perdus, endommagés, volés et même détruits. D'une autre part parce que des 
            informations sensibles peuvent se retrouver entre les mauvaises mains, accidentellement ou non.`,
            `Dans les deux cas, l'utilisation des outils adéquats combiné à l'accompagnement par un spécialiste permet 
            de protéger une organisation contre de telles éventualités.`
          ],
          button: {
            text: `(consultez notre blog pour en apprendre davantage)`,
            link: { name: `blog` }
          }
        },
        {
          icon: 'building',
          question: `La GED est-elle à la portée des petites et moyennes entreprises ?`,
          answer: [
            `Il fut effectivement un temps où les solutions disponibles n'étaient à la portée que des grandes 
            multinationnales. Ce n'est heureusement plus le cas.`,
            `Parmi les solutions disponibles, la plupart peuvent être configurées de manière à répondre aux besoins 
            d'une organisation, à l'envergure de celle-ci et à son niveau de maturité numérique.`
          ],
          button: {
            text: `(consultez notre blog pour en apprendre davantage)`,
            link: { name: `blog` }
          }
        },
        {
          icon: 'user-tie',
          question: `En quoi la GED est-elle un avantage dans un contexte de rareté de la main-d'oeuvre ?`,
          answer: [
            `Il n'y a qu'à regarder autour de soi pour le constater: la population acive diminue en nombre
            et la relève se fait de plus en plus attendre.`,
            `Le personnel qualifié est de plus en plus en demande et les entreprises sont de plus en plus disposées
            à offrir de meilleures conditions et une plus grande qualité de vie aux candidats convoités.`,
            `La GED et l'automatisation des processus d'affaires apportent une réponse originale à cette situation
            en réduisant considérablement la portion des charges de travail constituée de tâches répétitives et 
            prévisibles, augmentant à la fois la satisfaction de votre personnel et le rendement de votre entreprise.`,
          ],
          button: {
            text: `(consultez notre blog pour en apprendre davantage)`,
            link: { name: `blog` }
          }
        }
      ]
    }
  },
  methods: {
    titlize(title) {
        title = this.normalizeString( title.replace(/[\s\.,']/g, '-').toLowerCase() )

        return title
    },
    normalizeString(string) {
        return string.split('').map(function (letter) {
            let i = this.accents.indexOf(letter)
            return (i !== -1) ? this.out[i] : letter
            }.bind({
            accents: 'ÀÁÂÃÄÅĄàáâãäåąßÒÓÔÕÕÖØÓòóôõöøóÈÉÊËĘèéêëęðÇĆçćÐÌÍÎÏìíîïÙÚÛÜùúûüÑŃñńŠŚšśŸÿýŽŻŹžżź',
            out: 'AAAAAAAaaaaaaaBOOOOOOOOoooooooEEEEEeeeeeeCCccDIIIIiiiiUUUUuuuuNNnnSSssYyyZZZzzz'
            })
        ).join('')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card,
.card-header {
  background-color: transparent;
  border: none;
}

.card-header > a {
  border-radius: 0;
}

.card-header > a > div > .col-1 {
  transition: all 0.2s ease;
}

.card-header:hover > a > div > .col-1 {
  transform: scale(1.2);
}

.card-header:hover > a {
  color: #00B5E2;
}

.hr-theme-slash {
  display: flex;
}
  
.hr-theme-slash > .hr-line {
  width: 100%;
  position: relative;
  margin: 15px;
  border-bottom: 3px solid #fff;
}

.hr-theme-slash > .hr-icon {
  position: relative;
  top: 3px;
  color: #fff;
}
</style>
